import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const EyeIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M1 10C1 10 4.27273 4 10 4C15.7273 4 19 10 19 10C19 10 15.7273 16 10 16C4.27273 16 1 10 1 10Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.91667 12.8333C11.5275 12.8333 12.8333 11.5275 12.8333 9.91667C12.8333 8.30584 11.5275 7 9.91667 7C8.30584 7 7 8.30584 7 9.91667C7 11.5275 8.30584 12.8333 9.91667 12.8333Z"
                fill="none"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
